import React from "react";
import useChatbotLogic from "./useChatbotLogic";
import ChatWindow from "./ChatWindow";
import ChatFab from "./ChatFab";

const Chatbot: React.FC = () => {
  const {
    isOpen,
    setIsOpen,
    messages,
    input,
    status,
    currentStage,
    showMentions,
    filteredProperties,
    isLoadingProps,
    inputRef,
    messagesEndRef,
    scrollContainerRef,
    handleInputChange,
    handleSelectProperty,
    handleSend,
    handleStop,
    thinkingStages,
    previousChats,
    handleSelectPreviousChat,
    handleNewChat,
    loadMoreChats,
    isFetchingMore,
    hasMore,
    isLoadingHistory,
    deleteConversation,
    handleScrollMessages,
    isFetchingOlderMessages,
    handleWheelMessages,
    isRecording,
    isTranscribing,
    startRecording,
    stopRecording,
    activeAudioId,
    playbackState,
    onTogglePlayAudio,
  } = useChatbotLogic();

  return (
    <>
      <ChatFab isOpen={isOpen} setIsOpen={setIsOpen} />

      {isOpen && (
        <ChatWindow
          messages={messages}
          status={status}
          currentStage={currentStage}
          thinkingStages={thinkingStages}
          showMentions={showMentions}
          filteredProperties={filteredProperties}
          isLoadingProps={isLoadingProps}
          input={input}
          setIsOpen={setIsOpen}
          handleInputChange={handleInputChange}
          handleSelectProperty={handleSelectProperty}
          handleSend={handleSend}
          handleStop={handleStop}
          inputRef={inputRef}
          messagesEndRef={messagesEndRef}
          scrollContainerRef={scrollContainerRef}
          previousChats={previousChats}
          onSelectPreviousChat={handleSelectPreviousChat}
          onNewChat={handleNewChat}
          onLoadMoreChats={loadMoreChats}
          isFetchingMore={isFetchingMore}
          hasMore={hasMore}
          isLoadingHistory={isLoadingHistory}
          deleteConversation={deleteConversation}
          onScrollMessages={handleScrollMessages}
          isFetchingOlderMessages={isFetchingOlderMessages}
          onWheelMessages={handleWheelMessages}
          isRecording={isRecording}
          isTranscribing={isTranscribing}
          startRecording={startRecording}
          stopRecording={stopRecording}
          activeAudioId={activeAudioId}
          playbackState={playbackState}
          onTogglePlayAudio={onTogglePlayAudio}
        />
      )}
    </>
  );
};

export default Chatbot;